import { Container } from './Container'

const socialLinks = [
  { name: 'LinkedIn', href: 'https://www.linkedin.com/company/impact-real-estate-capital/', icon: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' },
] as const

export function Footer() {
  return (
    <footer className="bg-[#161616] border-t border-[#cab6a1]/30">
      <Container>
        <div className="py-10 sm:py-12">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
            <div>
              <p className="font-serif text-white text-lg sm:text-xl uppercase tracking-wide">Impact Real Estate Capital</p>
              <p className="text-white/50 text-sm mt-1 font-sans">Copyright © 2026</p>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-8">
              <nav className="flex items-center gap-6" aria-label="Footer navigation">
                <a
                  href="/"
                  className="text-white/50 hover:text-[#cab6a1] text-sm font-sans transition-colors focus:outline-none focus-visible:text-[#cab6a1] focus-visible:ring-2 focus-visible:ring-[#cab6a1] focus-visible:ring-offset-2 focus-visible:ring-offset-[#161616] rounded"
                >
                  Home
                </a>
                <a
                  href="#approach"
                  className="text-white/50 hover:text-[#cab6a1] text-sm font-sans transition-colors focus:outline-none focus-visible:text-[#cab6a1] focus-visible:ring-2 focus-visible:ring-[#cab6a1] focus-visible:ring-offset-2 focus-visible:ring-offset-[#161616] rounded"
                >
                  Our approach
                </a>
                <a
                  href="#contact"
                  className="text-white/50 hover:text-[#cab6a1] text-sm font-sans transition-colors focus:outline-none focus-visible:text-[#cab6a1] focus-visible:ring-2 focus-visible:ring-[#cab6a1] focus-visible:ring-offset-2 focus-visible:ring-offset-[#161616] rounded"
                >
                  Contact
                </a>
              </nav>
              <nav className="flex items-center gap-6" aria-label="Social links">
                {socialLinks.map(({ name, href, icon }) => (
                  <a
                    key={name}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/50 hover:text-[#cab6a1] transition-colors focus:outline-none focus-visible:text-[#cab6a1] focus-visible:ring-2 focus-visible:ring-[#cab6a1] focus-visible:ring-offset-2 focus-visible:ring-offset-[#161616] rounded"
                    aria-label={name}
                  >
                    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                      <path d={icon} />
                    </svg>
                  </a>
                ))}
              </nav>
              <a
                href="/privacy"
                className="text-white/50 hover:text-[#cab6a1] text-sm font-sans transition-colors focus:outline-none focus-visible:text-[#cab6a1] focus-visible:ring-2 focus-visible:ring-[#cab6a1] focus-visible:ring-offset-2 focus-visible:ring-offset-[#161616] rounded"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  )
}
